const tender_information_type = {
  namespaced: true,
  state: {
    pageType: 0, //页面类型  0-公告 1-预告 2-变更 3结果
    pageTypeName: "", //页面类型名称
    footerPleaseLink: [], //底部数据）
    industryNavigation: [], //行业导航
    qlmSubstation: [], //千里马分站
    searchData: [], //搜搜列表数据
    governmentOrgans: [], //政府机构
    tenderRecommendation: [], //招标推荐
    purchaseInstitutionList: [], //采购机构列表
    hotTenderList: [], //招标热点列表
    noticeUrlConfig: [], //nav招标地址
    areaInfo: {
      areaName: "全国",
      areaId: 2703,
    },
  },
  getters: {
    pageType: (state) => state.pageType,
    pageTypeName: (state) => state.pageTypeName,
    footerPleaseLink: (state) => state.footerPleaseLink,
    industryNavigation: (state) => state.industryNavigation,
    qlmSubstation: (state) => state.qlmSubstation,
    searchData: (state) => state.searchData,
    governmentOrgans: (state) => state.governmentOrgans,
    tenderRecommendation: (state) => state.tenderRecommendation,
    purchaseInstitutionList: (state) => state.purchaseInstitutionList,
    hotTenderList: (state) => state.hotTenderList,
    areaInfo: (state) => state.areaInfo,
    noticeUrlConfig: (state) => state.noticeUrlConfig,
  },
  mutations: {
    updateData(state, data) {
      for (const key in data) {
        state[key] = data[key];
      }
    },
    updateFooterPleaseLink(state, footerPleaseLink) {
      state.footerPleaseLink = footerPleaseLink;
    },
    updateIndustryNavigation(state, industryNavigation) {
      state.industryNavigation = industryNavigation;
    },
    updateQlmSubstation(state, qlmSubstation) {
      state.qlmSubstation = qlmSubstation;
    },
    updateGovernmentOrgans(state, governmentOrgans) {
      state.governmentOrgans = governmentOrgans;
    },
    updateTenderRecommendation(state, tenderRecommendation) {
      state.tenderRecommendation = tenderRecommendation;
    },
    updatePurchaseInstitutionList(state, purchaseInstitutionList) {
      state.purchaseInstitutionList = purchaseInstitutionList;
    },
    updateHotTenderList(state, hotTenderList) {
      state.hotTenderList = hotTenderList;
    },
    updateAreaInfo(state, areaInfo) {
      state.areaInfo = areaInfo;
    },
  },
  actions: {},
};
export default tender_information_type;
